// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachYearOfInterval as fn } from "../eachYearOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachYearOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachYearOfIntervalWithOptions;
